import { AlertTriangle } from "lucide-react";

// Prominent buyer warning shown when the contract discloses a branded (rebuilt/salvage) or prior
// total-loss vehicle. Advisory only — it does not change the compliance score.
export const ConditionNotice = ({ notice }) => {
  if (!notice) return null;
  return (
    <div
      data-testid="condition-notice-card"
      data-status={notice.status}
      className="rounded-xl border-2 border-destructive/60 bg-destructive-soft p-5 shadow-[0_0_24px_-6px_rgba(220,38,38,0.5)]"
    >
      <div className="flex items-start gap-3.5">
        <div
          className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-md border-2 border-destructive text-destructive"
          aria-hidden="true"
        >
          <AlertTriangle className="h-5 w-5" />
        </div>
        <div className="flex-1">
          <div className="flex items-center justify-between gap-3">
            <h4 className="font-heading text-base font-800 uppercase tracking-wide text-destructive">
              {notice.title}
            </h4>
            <span
              data-testid="condition-notice-badge"
              className="rounded-full border border-destructive/50 bg-background px-2.5 py-1 font-mono-plex text-[10px] font-700 uppercase tracking-[0.12em] text-destructive"
            >
              Branded title
            </span>
          </div>
          <p className="mt-1.5 text-sm leading-relaxed text-muted-foreground">{notice.message}</p>
        </div>
      </div>
    </div>
  );
};
